import type { RequestBody, ResponseBody } from "@src/packages/openapi/helpers";
import type { paths } from "@src/packages/openapi/schema";

type TreatmentPlanPath = paths["/patients/{patientId}/treatment-plan"];

export type AcceptedTreatmentPlanPayload = RequestBody<
  NonNullable<TreatmentPlanPath["post"]>
>;

export type AcceptedTreatmentPlan = NonNullable<
  ResponseBody<NonNullable<TreatmentPlanPath["get"]>>["data"]
>;

export type AcceptedTreatmentPlanDraft = Omit<
  AcceptedTreatmentPlanPayload,
  "expectedVersion" | "notes"
>;

export const INITIAL_ACCEPTED_TREATMENT_PLAN: AcceptedTreatmentPlanDraft = {
  treatmentFamily: "undecided",
  treatmentDestination: "undecided",
  ovulationApproach: "undecided",
  fertilizationMethod: "undecided",
  eggSource: "undecided",
  eggState: "undecided",
  spermSource: "undecided",
  spermState: "undecided",
  transferPlan: "undecided",
  pgtPlan: "undecided",
  decisionSource: "undecided",
};
